import { render } from "./Diploma.vue?vue&type=template&id=07b7d9df&scoped=true"
import script from "./Diploma.vue?vue&type=script&lang=js"
export * from "./Diploma.vue?vue&type=script&lang=js"

import "./Diploma.vue?vue&type=style&index=0&id=07b7d9df&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b7d9df"]])

export default __exports__